import { Settings } from '@bb-ui/icons/dist/small';
import { makeStyles, PrimaryButton, Tooltip } from '@bb-ui/react-library';
import { ReleaseStageUpgradeButtonDialog } from 'dialogs/ReleaseStageUpgradeButtonDialog';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface ReleaseStageUpgradeButtonProps {
  releaseStageId: string;
  releaseStageName: string;
  onSuccess: () => void;
  selectedInstallationIds?: string[];
  disabledReason?: string;
}

const useStyles = makeStyles((theme) => ({
  upgradeButton: {
    marginRight: theme.spacing(1),
  },
}));

export const ReleaseStageUpgradeButton: React.FunctionComponent<ReleaseStageUpgradeButtonProps> = (
  props,
) => {
  const { releaseStageId, releaseStageName, onSuccess, selectedInstallationIds, disabledReason } =
    props;
  const { t } = useTranslation();
  const [releaseStageUpgradeButtonDialogOpen, setReleaseStageUpgradeButtonDialogOpen] =
    React.useState(false);
  const classes = useStyles();
  return (
    <>
      <Tooltip title={disabledReason ?? ''}>
        <span>
          <PrimaryButton
            className={classes.upgradeButton}
            startIcon={<Settings />}
            data-testid="upgrade-all-release-stage-button"
            disabled={Boolean(disabledReason)}
            onClick={() => setReleaseStageUpgradeButtonDialogOpen(true)}
          >
            {t('releaseStages.upgradeButton')}
          </PrimaryButton>
        </span>
      </Tooltip>
      <ReleaseStageUpgradeButtonDialog
        id="upgrade-release-stage-dialog"
        onClose={() => setReleaseStageUpgradeButtonDialogOpen(false)}
        releaseStageId={releaseStageId}
        releaseStageName={releaseStageName}
        initialInstallationList={selectedInstallationIds}
        open={releaseStageUpgradeButtonDialogOpen}
        onSuccess={() => {
          setReleaseStageUpgradeButtonDialogOpen(false);
          onSuccess();
        }}
      />
    </>
  );
};
